import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../../lib/result-codes";
import { merchantCouponRedeemerApi } from "../api/merchantCouponRedeemer.api";
import type { CouponRedeemResult } from "../types/merchantCouponRedeemer.types";

interface UseRedeemCouponByQrReturn {
  execute: (qrToken: string) => Promise<CouponRedeemResult | undefined>;
  isLoading: boolean;
  error: string | null;
}

export const useRedeemCouponByQr = (): UseRedeemCouponByQrReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const execute = useCallback(
    async (qrToken: string) => {
      if (isLoading) return undefined;

      setIsLoading(true);
      setError(null);
      try {
        return await merchantCouponRedeemerApi.verifyCouponQr(qrToken);
      } catch (requestError: unknown) {
        const message = getApiErrorMessage(
          requestError,
          "Failed to redeem coupon. Please try again.",
        );
        setError(message);
        throw new Error(message);
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading],
  );

  return { execute, isLoading, error };
};
